import { atom, useAtomValue } from '@exodus/headless-ui';
import React from 'react';
import { fromAmountAtom, isExchangingAtom, prefillIdAtom, preventFromExchangingAtom, swapModeAtom, toAmountAtom, warningAtom, } from '../../../atoms/index.js';
const isVisibleAtom = atom((get) => {
    const fromAmount = get(fromAmountAtom);
    const toAmount = get(toAmountAtom);
    const prefillId = get(prefillIdAtom);
    const swapMode = get(swapModeAtom);
    const currentWarning = get(warningAtom);
    const isExchanging = get(isExchangingAtom);
    const preventFromExchanging = get(preventFromExchangingAtom);
    const didUserInteract = (swapMode === 'ExactIn' ? fromAmount.isPositive : toAmount.isPositive) || !!prefillId;
    return didUserInteract && !!currentWarning && !isExchanging && !preventFromExchanging;
});
const WarningComponent = ({ Component, className, style }) => {
    const isVisible = useAtomValue(isVisibleAtom);
    const currentWarning = useAtomValue(warningAtom);
    if (!isVisible || !Component || !currentWarning) {
        return null;
    }
    return (React.createElement(Component, { type: currentWarning.type, reason: currentWarning.reason, payload: currentWarning.payload, className: className, style: style }));
};
export default WarningComponent;
